import React from 'react';
import { ArrowLeft, TrendingUp, TrendingDown, DollarSign, CreditCard, Users, Activity } from 'lucide-react';
import { Link } from 'react-router-dom';

const FintechDashboard = () => {
  const stats = [
    { label: 'Total Balance', value: '$124,563.89', change: '+12.5%', trend: 'up', icon: <DollarSign size={24} /> },
    { label: 'Monthly Income', value: '$8,450.00', change: '+8.2%', trend: 'up', icon: <CreditCard size={24} /> },
    { label: 'Active Users', value: '2,847', change: '+15.3%', trend: 'up', icon: <Users size={24} /> },
    { label: 'Transactions', value: '1,234', change: '-3.1%', trend: 'down', icon: <Activity size={24} /> },
  ];

  const transactions = [
    { id: 1, description: 'Payment from Client A', amount: '+$5,000.00', date: '2024-01-15', type: 'income' },
    { id: 2, description: 'Subscription Payment', amount: '-$29.99', date: '2024-01-14', type: 'expense' },
    { id: 3, description: 'Freelance Project', amount: '+$2,500.00', date: '2024-01-13', type: 'income' },
    { id: 4, description: 'Office Supplies', amount: '-$145.50', date: '2024-01-12', type: 'expense' },
    { id: 5, description: 'Investment Return', amount: '+$1,200.00', date: '2024-01-11', type: 'income' },
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-white pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link
          to="/portfolio"
          className="inline-flex items-center gap-2 text-primary-400 hover:text-primary-300 mb-8"
        >
          <ArrowLeft size={20} />
          Back to Portfolio
        </Link>

        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2">Fintech Dashboard</h1>
          <p className="text-gray-400">Real-time financial analytics and transaction management</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <div className="flex items-center justify-between mb-4">
                <div className="text-primary-400">{stat.icon}</div>
                <div className={`flex items-center gap-1 text-sm ${
                  stat.trend === 'up' ? 'text-green-400' : 'text-red-400'
                }`}>
                  {stat.trend === 'up' ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
                  {stat.change}
                </div>
              </div>
              <p className="text-gray-400 text-sm mb-1">{stat.label}</p>
              <p className="text-2xl font-bold">{stat.value}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Chart Area */}
          <div className="lg:col-span-2 bg-gray-800 rounded-lg p-6 border border-gray-700">
            <h2 className="text-xl font-semibold mb-4">Revenue Overview</h2>
            <div className="h-64 bg-gradient-to-br from-primary-600/20 to-primary-800/20 rounded-lg flex items-center justify-center">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">$124.5K</div>
                <div className="text-green-400 text-sm">+12.5% from last month</div>
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
            <h2 className="text-xl font-semibold mb-4">Recent Transactions</h2>
            <div className="space-y-4">
              {transactions.map((transaction) => (
                <div key={transaction.id} className="flex items-center justify-between pb-4 border-b border-gray-700 last:border-0">
                  <div>
                    <p className="font-medium">{transaction.description}</p>
                    <p className="text-sm text-gray-400">{transaction.date}</p>
                  </div>
                  <p className={`font-semibold ${
                    transaction.type === 'income' ? 'text-green-400' : 'text-red-400'
                  }`}>
                    {transaction.amount}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FintechDashboard;

